import { TransformDate } from '../../../shared/decorators/transform-date.decorator';
import { ApiRequestFilters } from '../../../shared/types/api-request-filters';
import { VehicleDamageFaultEnum } from '../enums/vehicle-damage-fault.enum';
import { VehicleDamageRecordCategoryEnum } from '../enums/vehicle-damage-record-category.enum';
import { VehicleDamageSeverityEnum } from '../enums/vehicle-damage-severity.enum';
import { VehicleDamageStatusEnum } from '../enums/vehicle-damage-status.enum';
import { VehicleDamageTypeEnum } from '../enums/vehicle-damage-type.enum';

/**
 * Vehicle damages filters
 */
export class VehicleDamagesFilters extends ApiRequestFilters {
	/**
	 * Fault values
	 */
	faults?: VehicleDamageFaultEnum[];

	/**
	 * Type values
	 */
	types?: VehicleDamageTypeEnum[];

	/**
	 * Severity values
	 */
	severities?: VehicleDamageSeverityEnum[];

	/**
	 * Reported from date
	 */
	@TransformDate()
	reportedAtFrom?: Date;

	/**
	 * Reported to date
	 */
	@TransformDate()
	reportedAtTo?: Date;

	/**
	 * Gross amount from
	 */
	estimatedCostFrom?: number;

	/**
	 * Gross amount from
	 */
	estimatedCostTo?: number;

	/**
	 * Vehicles id values
	 */
	vehicles?: number[];

	/**
	 * Rental Agreements id values
	 */
	rentalAgreements?: number[];

	/**
	 * Vehicle Maintenances id values
	 */
	vehicleMaintenances?: number[];

	/**
	 * Customers id values
	 */
	customers?: number[];

	/**
	 * Status enum value
	 */
	statuses?: VehicleDamageStatusEnum[];

	/**
	 * Record category enum values
	 */
	recordCategories?: VehicleDamageRecordCategoryEnum[];

	/**
	 * Vehicle category id values
	 */
	vehicleCategories?: number[];

	/**
	 * Tag id values
	 */
	tags?: number[];
}
